import InputUpload from '@app/components/atoms/Images/InputUpload'
import LabelField from '@app/components/atoms/LabelField/LabelField'
import Section from '@app/components/atoms/Section/Section'
import { yupResolver } from '@hookform/resolvers/yup'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import CategoryEditSchema from './CategoryEditSchema'

const TypographyError = styled(Typography)({
  color: '#d32f2f',
  paddingLeft: 14,
})

const CategoryEdit = ({ category }) => {
  const { t } = useTranslation()

  const initialValues = {
    ...category,
    thumbnail: [category.thumbnail],
    background: [category.background],
  }

  const {
    register,
    control,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: initialValues,
    resolver: yupResolver(CategoryEditSchema),
  })

  const onSubmit = (data) => {
    Inertia.put(route('admin.categories.update', category.id), data, {
      onError: (errors) => {
        setError('name', { message: t(errors.name) })
      },
    })
  }
  const onError = (errors, e) => {}

  return (
    <Grid container component="form" spacing={2} onSubmit={handleSubmit(onSubmit, onError)}>
      <Grid item xs={12}>
        <Section title={t('CATEGORIES.BASIC_INFORMATION')}>
          <Grid item lg={7} md={12} sm={12} xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <LabelField required title={t('CATEGORIES.NAME')}>
                  <TextField
                    fullWidth
                    name="name"
                    size="small"
                    variant="outlined"
                    {...register('name')}
                    error={errors.name ? true : false}
                    helperText={errors.name?.message}
                  />
                </LabelField>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section title={t('CATEGORIES.IMAGES')}>
          <Grid item lg={7} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <LabelField required recommend={t('VOUCHER.SLIDER_RECOMMEND')} title={t('CATEGORIES.THUMBNAIL')}>
                  <Controller
                    control={control}
                    name="thumbnail"
                    render={({ field }) => (
                      <InputUpload
                        {...field}
                        buttonName={t('CAMPAIGN.UPLOAD_SLIDER')}
                        clearErrors={clearErrors}
                        handleImageChange={(files) => setValue('thumbnail', files)}
                        id="thumbnail"
                        name="thumbnail"
                        ref={field.ref}
                        setError={setError}
                        title={t('CAMPAIGN.UPLOAD_SLIDER')}
                        value={getValues('thumbnail')}
                      />
                    )}
                    title={t('CAMPAIGN.UPLOAD_SLIDER')}
                  />
                  {errors.thumbnail && <TypographyError variant="caption">{errors.thumbnail?.message}</TypographyError>}
                </LabelField>
              </Grid>

              <Grid item xs={12}>
                <LabelField required recommend={t('VOUCHER.SLIDER_RECOMMEND')} title={t('CATEGORIES.BACKGROUND')}>
                  <Controller
                    control={control}
                    name="background"
                    render={({ field }) => (
                      <InputUpload
                        {...field}
                        buttonName={t('CAMPAIGN.UPLOAD_SLIDER')}
                        clearErrors={clearErrors}
                        handleImageChange={(files) => setValue('background', files)}
                        id="background"
                        name="background"
                        ref={field.ref}
                        setError={setError}
                        title={t('CAMPAIGN.UPLOAD_SLIDER')}
                        value={getValues('background')}
                      />
                    )}
                    title={t('CAMPAIGN.UPLOAD_SLIDER')}
                  />
                  {errors.background && (
                    <TypographyError variant="caption">{errors.background?.message}</TypographyError>
                  )}
                </LabelField>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs="auto">
        <Button color="primary" type="submit" variant="contained">
          {t('BUTTON.SAVE')}
        </Button>
      </Grid>

      <Grid item xs="auto">
        <Button color="inherit" component={InertiaLink} href={route('admin.categories.index')} variant="contained">
          {t('BUTTON.CANCEL')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default CategoryEdit
